/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

// import timeSlot from '../../../../../assets/about/time-slot.svg';
import phone from '../../../../../assets/about/phone.svg';
import globe from '../../../../../assets/about/globe.svg';
import mail from '../../../../../assets/about/mail.svg';

import stationFooterStyle from './location-footer.styles';
import { useParams } from 'react-router-dom';
import { useGetLocationByIdQuery } from '../../../../../api/locations/locations.api';
import { toAbsoluteUrl } from '../../../../../utils/utils';

type TProps = {
    shouldShowAboutTitle?: boolean;
    styles?: any;
};

export const LocationFooter: FC<TProps> = props => {
    const { shouldShowAboutTitle = true, styles = {} } = props;
    const intl = useIntl();
    const { locationId } = useParams();
    const { data, isLoading: isLocationLoading } = useGetLocationByIdQuery(locationId ?? '');

    const location = data?.data;

    if (isLocationLoading) {
        return null;
    }

    return (
        <>
            <div css={[stationFooterStyle.container, styles]}>
                {location && shouldShowAboutTitle && (
                    <div css={stationFooterStyle.title}>
                        {intl.formatMessage({ id: 'footer.title.aboutLocation' })}
                    </div>
                )}

                <div css={stationFooterStyle.content}>
                    {location?.phoneNumber && (
                        <div css={stationFooterStyle.infoBlock}>
                            <div css={stationFooterStyle.infoBlockIcon}>
                                <img width={23} src={phone} alt={'Support'} />
                            </div>
                            <a
                                css={stationFooterStyle.infoBlockValue}
                                href={`tel:${location?.phoneNumber}`}
                                target={'_blank'}
                                rel="noreferrer">
                                {location?.phoneNumber}
                            </a>
                        </div>
                    )}

                    {/* {location?.workingHours && (
                        <div css={stationFooterStyle.infoBlock}>
                            <div css={stationFooterStyle.infoBlockIcon}>
                                <img height={23} src={timeSlot} alt={'Working hours'} />
                            </div>
                            <div>
                                <div css={stationFooterStyle.infoBlockValue}>
                                    {location?.workingHours}
                                </div>
                            </div>
                        </div>
                    )} */}

                    {location?.email && (
                        <div css={stationFooterStyle.infoBlock}>
                            <div css={stationFooterStyle.infoBlockIcon}>
                                <img width={23} src={mail} alt={'E-mail'} />
                            </div>
                            <div>
                                <div>
                                    <a
                                        target="_blank"
                                        css={stationFooterStyle.infoBlockValue}
                                        href={`mailto:${location?.email}`}
                                        rel="noreferrer">
                                        {location?.email}
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}

                    {location?.website && (
                        <div css={stationFooterStyle.infoBlock}>
                            <div css={stationFooterStyle.infoBlockIcon}>
                                <img height={23} src={globe} alt={'Website'} />
                            </div>
                            <div>
                                <div css={stationFooterStyle.infoBlockValue}>
                                    <a
                                        css={stationFooterStyle.link}
                                        href={toAbsoluteUrl(location?.website)}
                                        target={'_blank'}
                                        rel="noreferrer">
                                        {location?.website}
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}

                    {location?.description && (
                        <p css={stationFooterStyle.description}>{location?.description}</p>
                    )}
                </div>
            </div>
        </>
    );
};
